module.exports = __webpack_public_path__ + "static/media/spicysalmon.a0b9604b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/protein/spicysalmon.jpg
// module id = 112
// module chunks = 0